import React from "react";
import styles from "./LeadActivityItem.module.css";

const TYPE_META = {
  STAGE_CHANGE: { icon: "🔁", label: "Estágio alterado" },
  NOTE: { icon: "📝", label: "Nota" },
  CONVERSION: { icon: "🏆", label: "Convertido em cliente" },
  ASSIGNMENT: { icon: "👤", label: "Atribuição" },
  CALL: { icon: "📞", label: "Ligação" },
};

/**
 * LeadActivityItem — item do feed cronológico de histórico do lead.
 *
 * Props:
 *   activity {{ id, type, content, metadata, createdAt }}
 *   stageLabels {Record<string,string>}  — mapa stage → label humanizado (pra STAGE_CHANGE)
 */
export default function LeadActivityItem({ activity, stageLabels = {} }) {
  const meta = TYPE_META[activity.type] || { icon: "•", label: activity.type };

  const renderBody = () => {
    if (activity.type === "STAGE_CHANGE") {
      const from = activity.metadata?.fromStage;
      const to = activity.metadata?.toStage;
      if (from && to) {
        const fromLabel = stageLabels[from] || from;
        const toLabel = stageLabels[to] || to;
        return (
          <p className={styles.body}>
            {fromLabel} <span aria-hidden="true">→</span> <strong>{toLabel}</strong>
          </p>
        );
      }
    }
    if (activity.content) {
      return <p className={styles.body}>{activity.content}</p>;
    }
    return null;
  };

  return (
    <article className={styles.item} aria-label={meta.label}>
      <div className={styles.iconWrap} aria-hidden="true">
        <span className={styles.icon}>{meta.icon}</span>
      </div>
      <div className={styles.content}>
        <p className={styles.label}>{meta.label}</p>
        {renderBody()}
        <time className={styles.date} dateTime={activity.createdAt}>
          {formatDateTime(activity.createdAt)}
        </time>
      </div>
    </article>
  );
}

function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
